/* Generated by TinySVG. Do not edit directly. */
import type { TinyIconProps } from '../types.ts'

export function ReloadIcon({
  size = 24,
  color = 'currentColor',
  strokeWidth,
  title,
  ...svgProps
}: TinyIconProps) {
  const resolvedStrokeWidth = strokeWidth ?? 1.75
  const scaledStrokeWidth = (percent: number) => {
    const numericStrokeWidth = typeof resolvedStrokeWidth === 'number' ? resolvedStrokeWidth : Number(resolvedStrokeWidth)
    return Number.isFinite(numericStrokeWidth) ? numericStrokeWidth * percent / 100 : resolvedStrokeWidth
  }
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      strokeWidth={resolvedStrokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
      data-icon="reload"
      data-variant="outline"
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      focusable="false"
      {...svgProps}
    >
      {title ? <title>{title}</title> : null}
          <path d="M2.5 12A9.5 9.5 0 0 1 20.596 7.955" data-tinysvg-shape="arc" data-tinysvg-arc="12 12 9.5 9.5 180 334.799 0 center" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M21.5 3.5L21.5 8.5L16.5 8.5" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M21.5 12A9.5 9.5 0 0 1 3.404 16.045" data-tinysvg-shape="arc" data-tinysvg-arc="12 12 9.5 9.5 0 154.799 0 center" stroke={color} fill="none" data-stroke-tone="primary" />
          <path d="M2.5 20.5L2.5 15.5L7.5 15.5" data-tinysvg-shape="path" stroke={color} fill="none" data-stroke-tone="primary" />
    </svg>
  )
}
